import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ChatbotLayoutComponent } from './shared/components/layouts/chatbot-layout/chatbot-layout.component';
import { AdminLayoutSidebarLargeComponent } from './shared/components/layouts/admin-layout-sidebar-large/admin-layout-sidebar-large.component';
import { NoticationsRoutingModule } from './dce-views/notications/notications-routing.module';
import { AuthLayoutComponent } from './shared/components/layouts/auth-layout/auth-layout.component';
import { Resolver } from './resolver';
import { AuthGaurd } from './services/auth.guard';

let adminRoutes: Routes = [
  {
    path: '',
    component: ChatbotLayoutComponent,
    children: [
      {
        path: 'chat',
        loadChildren: () => import('./views/chatbot/chatbot.module').then(m => m.ChatbotModule)
      },
      {
        path: 'others',
        loadChildren: () => import('./views/others/others.module').then(m => m.OthersModule)
      }
    ]
  },
  {
    path: 'notifications',
    // component : AdminLayoutSidebarLargeComponent,
    loadChildren: () => import('./dce-views/notications/notications.module').then(m => m.NoticationsModule)
  },
  // {
  //   path : 'demo',
  //   // component : AdminLayoutSidebarLargeComponent
  // },
  {
    path:'chatbot',
    // component : AdminLayoutSidebarLargeComponent,
    loadChildren: ()=> import ('./dce-views/chatbot-crud/chatbot-crud.module').then(m=>m.ChatbotCrudModule)

  },
  {
      path: 'roles',
      loadChildren: () => import('./dce-views/roles/roles.module').then(m => m.RolesModule)
    },
  {
    path:'user',
    // component : AdminLayoutSidebarLargeComponent,
    loadChildren: ()=> import ('./dce-views/user-crud/user-crud.module').then(m=>m.UserCrudModule)

  },
  {
      path: 'user-profile',
      loadChildren: () => import('./dce-views/user-profile/user-profile.module').then(m => m.UserProfileModule)
    },
  {
    path:'journey',
    // component : AdminLayoutSidebarLargeComponent,
    loadChildren: ()=> import ('./dce-views/chatbot-crud/chatbot-crud.module').then(m=>m.ChatbotCrudModule)

  },
  {
      path: 'home',
      loadChildren: () => import('./views/home/home.module').then(m => m.HomeModule)
    },
  {
    path:'components-crud',
    loadChildren: ()=> import ('./dce-views/components-crud/components-crud.module').then(m=>m.ComponentsCrudModule)
  },
  {
    path: 'apps',
    loadChildren: () => import('./dce-views/manage-apps/manage-apps.module').then(m => m.ManageAppsModule)
  }

]

const routes: Routes = [
  {
    path: '',
    redirectTo: 'sessions/signin',//'/chat/-1',  sessions/signin
    pathMatch: 'full'
  },
  {
    path: '',
    component: AuthLayoutComponent,
    children: [
      {
        path: 'sessions',
        loadChildren: () => import('./views/sessions/sessions.module').then(m => m.SessionsModule)
      },
      
    ]
  },
  // {
  //   path: '',
  //   component: BlankLayoutComponent,
  //   children: [
  //     {
  //       path: 'others',
  //       loadChildren: () => import('./views/others/others.module').then(m => m.OthersModule)
  //     }
  //   ]
  // },
  {
    path: '',
    resolve: { roles_map: Resolver },
    component: AdminLayoutSidebarLargeComponent,
    canActivate: [AuthGaurd],
    children: adminRoutes, 
  },
  {
    path: '**',
    redirectTo: 'others/404'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true, scrollPositionRestoration: 'enabled', enableTracing: false })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
